export default (number: number, isForceDecimal?: boolean) => {
    // Round number until 2nd decimal
    const roundedNumber = Math.round(Number(number) * 100) / 100;

    // Convert to string and split the integer and decimal parts
    const parts = roundedNumber.toString().split('.');

    // Format the integer part
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Format the decimal part
    if (parts[1]?.length === 1) {
        parts[1] += '0';
    }
    if (isForceDecimal && !parts[1]) {
        parts[1] = '00';
    }

    // Join the formatted parts and return the result
    return parts.join('.');
};
